import type { WorkshopSubmission } from '@mio/shared';

const score = { met: 2, partial: 1, not_met: 0 };

/** Compare observations only when both reviews used the same assessment contract. */
export function compareReviews(current: WorkshopSubmission, previous: WorkshopSubmission) {
  const next = current.evaluation;
  const prior = previous.evaluation;
  if (
    !next ||
    !prior ||
    !('version' in next) ||
    !('version' in prior) ||
    current.evaluationVersion !== previous.evaluationVersion ||
    current.modelId !== previous.modelId ||
    next.rubricRevision !== prior.rubricRevision ||
    next.criteria.length !== prior.criteria.length
  )
    return null;
  const before = new Map(prior.criteria.map((item) => [item.id, item]));
  const changes = [];
  for (const item of next.criteria) {
    const old = before.get(item.id);
    if (old?.required !== item.required || old.dimension !== item.dimension) return null;
    changes.push({ id: item.id, before: old.result, after: item.result });
  }

  return {
    improved: changes.filter((item) => score[item.after] > score[item.before]),
    regressed: changes.filter((item) => score[item.after] < score[item.before]),
    unchangedPending: changes.filter((item) => item.after !== 'met' && item.after === item.before),
  };
}
